module.exports = __webpack_public_path__ + "img/banner02.bf420c1f.jpg";